"use strict";
/**
 * Moderation `reviews` canonical template — single source of truth for the
 * `moderation-reviews` OpenSearch index family (registered by the setup lambda).
 *
 * Moderation families are REGISTRAR-ONLY (setup lambda registers; moderation-history
 * reads by alias), have NO search-document interface, and are NOT read by application
 * search queries — so they expose a TEMPLATE BUILDER ONLY (no `*_FIELDS` constants, no
 * interface). Field types ported VERBATIM from the setup lambda's inline
 * `moderation-reviews` block. No analyzers (plain mappings), so `settings.analysis`
 * is OMITTED. `scan_details` stays UNMAPPED — handled by `dynamic: true`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildModerationReviewsTemplate = buildModerationReviewsTemplate;
/** Build the composable OpenSearch index-template body for the `moderation-reviews` family. */
function buildModerationReviewsTemplate(opts) {
    return {
        index_patterns: [opts.pattern],
        template: {
            settings: {
                number_of_shards: opts.shards ?? 1,
                number_of_replicas: opts.replicas ?? 0,
                refresh_interval: opts.refresh ?? '5s',
            },
            mappings: {
                dynamic: true,
                properties: {
                    moderation_id: { type: 'keyword' },
                    pattern_id: { type: 'keyword' },
                    reviewer_id: { type: 'keyword' },
                    reviewer_name: { type: 'keyword' },
                    review_text: { type: 'text' },
                    review_rating: { type: 'integer' },
                    status: { type: 'keyword' },
                    audit_decision: { type: 'keyword' },
                    auto_blocked: { type: 'boolean' },
                    resolved_by: { type: 'keyword' },
                    created_at: { type: 'date' },
                    resolved_at: { type: 'date' },
                },
            },
        },
        priority: 100,
        _meta: { managed_by: 'fpw', purpose: 'moderation-reviews' },
    };
}
